<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="job-content">
                    <div class="card col-sm-7 mx-auto text-left" id="job-content-text">
                        <h5>Hi {{getName}} 👋 </h5><br>
                        <div class="details">Please fill out details about your portfolio. Your approval 
                            chances will increase with a complete portfolio
                        </div>
                        <DetailsForm from_profile="false" v-bind:job_category="jobCategory" @submit="uploadContent"></DetailsForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import firebase from '../services/firebase'
import DetailsForm from '@/components/DetailsForm.vue'

export default {
    name: 'Details',
    data: function() {
        return {
            logged_in_user: null,
            jobs: [],
            job: null,
            appliedUsers: [],
            jobKey: ''
        }
    },
    components: {
        NavBarLight,
        DetailsForm
    },
    created: function() {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.logged_in_user = user;
            } 
        });
    },
    firebase: {
        jobs: firebase.database().ref('jobs')
    },
    computed: {
        getName: function() {
            var full_name = '';
            if (this.logged_in_user) {
                full_name = this.logged_in_user.displayName;
                console.log("full name is " + full_name);
            } else {
                full_name = "there";
            }
            
            return full_name;
        },
        jobCategory: function() {
            for (var key in this.jobs) {
                console.log("slug is " + this.jobs[key].slug);
                if (this.jobs[key].slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.jobs[key].slug);
                    return this.jobs[key].job_category;
                }
            }
        },
        jobsObj: function() {
            for (var key in this.jobs) {
                console.log("slug is " + this.jobs[key].slug);
                if (this.jobs[key].slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.jobs[key].slug);
                    this.jobKey = this.jobs[key]['.key'];
                    this.appliedUsers = this.jobs[key].Applied_users;
                    return this.jobs[key];
                }
            }
        },
        hasApplied: function() {
            for (var i in this.appliedUsers) {
                if (this.appliedUsers[i] === firebase.auth().currentUser.uid) {
                    return true;
                }
            }
            return false;
        }
        
    },
    methods: {
        uploadContent: function(resume, links) {
            const promises = [];
            var resumeLocation = "images/" + this.logged_in_user.uid + 
            "/resume/";
            if (resume) {
                var uploadTask = firebase.storage().ref().child("/" + resumeLocation).put(resume);
                promises.push(uploadTask);
            }
            
            var displayUrl = '';
            var date = "answered " + new Date().toDateString();
            var mytimestamp = new Date().getTime();
            var split_arr = this.logged_in_user.email.split("@", 2);
            var uname = split_arr[0];
            var num_upvotes = 0;

            let behanceLink = null;
            let dribbbleLink = null;
            let githubLink = null;
            let linkedinLink = null;
            let phoneNumber = null;
            let currentCTC = null;
            let noticePeriod = null;
            
            
            //console.log("In Details component, need to upload file " + resume.name);
            console.log("In Details component, need to upload links: behance is " + links.behanceLink);
            console.log("job object from computed property is " + this.jobsObj.slug);

            if (resume) {

            
                Promise.all(promises).then(tasks => {
                    firebase.storage().ref().child("/" + resumeLocation).getDownloadURL().then((url) => {
                        if (links.behanceLink) {
                            behanceLink = links.behanceLink;
                        }
                        

                        if (links.dribbbleLink) {
                            dribbbleLink = links.dribbbleLink;
                        }
                        

                        if (links.linkedinLink) {
                            linkedinLink = links.linkedinLink;
                        }


                        if (links.githubLink) {
                            githubLink = links.githubLink;
                        }

                        if (links.phoneNumber) {
                            phoneNumber = links.phoneNumber;
                        }

                        if (links.currentCTC) {
                            currentCTC = links.currentCTC;
                        }

                        if (links.noticePeriod) {
                            noticePeriod = links.noticePeriod;
                        }
                        

                        firebase.database().ref('users/' + this.logged_in_user.uid).update({
                            behance: behanceLink, 
                            dribbble: dribbbleLink, 
                            linkedin: linkedinLink, 
                            github: githubLink,
                            phone: phoneNumber,
                            resume: url,
                            ctc: currentCTC,
                            notice_period: noticePeriod
                        });

                        
                        firebase.database().ref('user_submissions/' + this.logged_in_user.uid + '/' + 
                        this.$route.params.slug).set({
                            date_created: date,
                            timestamp: mytimestamp,
                            jobSlug: this.jobsObj.slug,
                            job: this.jobsObj['.key'],
                            jobIcon: this.jobsObj.icon,
                            display_img_url: displayUrl,
                            resume: url,
                            behance: behanceLink,
                            dribbble: dribbbleLink,
                            linkedin: linkedinLink,
                            github: githubLink,
                            phone: phoneNumber,
                            user_id: this.logged_in_user.uid,
                            email: this.logged_in_user.email,
                            name: this.logged_in_user.displayName,
                            photoURL: this.logged_in_user.photoURL,
                            username: uname,
                            purpose: "job",
                            status: "In Review",
                            ctc: currentCTC,
                            notice_period: noticePeriod
                        });

                        firebase.database().ref('submissions/applications/' + this.$route.params.slug + '/' 
                        + this.logged_in_user.uid).set({
                            date_created: date,
                            timestamp: mytimestamp,
                            jobSlug: this.jobsObj.slug,
                            job: this.jobsObj['.key'],
                            display_img_url: displayUrl,
                            resume: url,
                            behance: behanceLink,
                            dribbble: dribbbleLink,
                            linkedin: linkedinLink,
                            github: githubLink,
                            phone: phoneNumber,
                            user_id: this.logged_in_user.uid,
                            email: this.logged_in_user.email,
                            name: this.logged_in_user.displayName,
                            photoURL: this.logged_in_user.photoURL,
                            username: uname,
                            purpose: "job",
                            status: "In Review",
                            ctc: currentCTC,
                            notice_period: noticePeriod
                        });

                        mixpanel.track("details_submitted", {
                            "user_id": this.logged_in_user.uid,
                            "behance": behanceLink,
                            "dribbble": dribbbleLink,
                            "linkedin": linkedinLink,
                            "github": githubLink,
                            "phone": phoneNumber,
                            "current_ctc": currentCTC,
                            "notice_period": noticePeriod
                        });

                        mixpanel.track("applied for job", {
                            "company_job": this.$route.params.slug,
                            "user_id": this.logged_in_user.uid,
                            "behance": behanceLink,
                            "dribbble": dribbbleLink,
                            "linkedin": linkedinLink,
                            "github": githubLink,
                            "phone": phoneNumber,
                            "current_ctc": currentCTC,
                            "notice_period": noticePeriod
                        });

                        if (!this.hasApplied) {
                            console.log("user " + this.logged_in_user.uid + " has not applied before");
                            if (this.appliedUsers !== undefined) {
                                for(var i in this.appliedUsers) {
                                    console.log("user registered for the job is " + this.appliedUsers[i]);
                                    length ++;
                                }

                                this.appliedUsers[length] = this.logged_in_user.uid;
                            }

                            else {
                                this.appliedUsers = [];
                                this.appliedUsers[length] = this.logged_in_user.uid;
                            }
                            
                            firebase.database().ref('jobs/' + this.jobKey).update({Applied_users: this.appliedUsers});
                        }

                        this.$router.push(this.$route.path + "/applied");
                    });
                });
            }


            //no resume uploaded, it's okay

            else { 

                if (links.behanceLink) {
                    behanceLink = links.behanceLink;
                }
                

                if (links.dribbbleLink) {
                    dribbbleLink = links.dribbbleLink;
                }
                

                if (links.linkedinLink) {
                    linkedinLink = links.linkedinLink;
                }


                if (links.githubLink) {
                    githubLink = links.githubLink;
                }

                if (links.phoneNumber) {
                    phoneNumber = links.phoneNumber;
                }
                
                if (links.currentCTC) {
                    currentCTC = links.currentCTC;
                }

                if (links.noticePeriod) {
                    noticePeriod = links.noticePeriod;
                }

                firebase.database().ref('users/' + this.logged_in_user.uid).update({
                    behance: behanceLink, 
                    dribbble: dribbbleLink, 
                    linkedin: linkedinLink, 
                    github: githubLink,
                    phone: phoneNumber,
                    ctc: currentCTC,
                    notice_period: noticePeriod
                });

                
                firebase.database().ref('user_submissions/' + this.logged_in_user.uid + '/' + 
                this.$route.params.slug).set({
                    date_created: date,
                    timestamp: mytimestamp,
                    jobSlug: this.jobsObj.slug,
                    job: this.jobsObj['.key'],
                    jobIcon: this.jobsObj.icon,
                    display_img_url: displayUrl,
                    behance: behanceLink,
                    dribbble: dribbbleLink,
                    linkedin: linkedinLink,
                    github: githubLink,
                    phone: phoneNumber,
                    user_id: this.logged_in_user.uid,
                    email: this.logged_in_user.email,
                    name: this.logged_in_user.displayName,
                    photoURL: this.logged_in_user.photoURL,
                    username: uname,
                    purpose: "job",
                    status: "In Review",
                    ctc: currentCTC,
                    notice_period: noticePeriod
                });

                firebase.database().ref('submissions/applications/' + this.$route.params.slug + '/' 
                + this.logged_in_user.uid).set({
                    date_created: date,
                    timestamp: mytimestamp,
                    jobSlug: this.jobsObj.slug,
                    job: this.jobsObj['.key'],
                    display_img_url: displayUrl,
                    behance: behanceLink,
                    dribbble: dribbbleLink,
                    linkedin: linkedinLink,
                    github: githubLink,
                    phone: phoneNumber,
                    user_id: this.logged_in_user.uid,
                    email: this.logged_in_user.email,
                    name: this.logged_in_user.displayName,
                    photoURL: this.logged_in_user.photoURL,
                    username: uname,
                    purpose: "job",
                    status: "In Review",
                    ctc: currentCTC,
                    notice_period: noticePeriod
                });

                mixpanel.track("details_submitted", {
                    "user_id": this.logged_in_user.uid,
                    "behance": behanceLink,
                    "dribbble": dribbbleLink,
                    "linkedin": linkedinLink,
                    "github": githubLink,
                    "phone": phoneNumber,
                    "current_ctc": currentCTC,
                    "notice_period": noticePeriod
                });

                mixpanel.track("applied for job", {
                    "company_job": this.$route.params.slug,
                    "user_id": this.logged_in_user.uid,
                    "behance": behanceLink,
                    "dribbble": dribbbleLink,
                    "linkedin": linkedinLink,
                    "github": githubLink,
                    "phone": phoneNumber,
                    "current_ctc": currentCTC,
                    "notice_period": noticePeriod
                });

                if (!this.hasApplied) {
                    console.log("user " + this.logged_in_user.uid + " has not applied before");
                    if (this.appliedUsers !== undefined) {
                        for(var i in this.appliedUsers) {
                            console.log("user registered for the job is " + this.appliedUsers[i]);
                            length ++;
                        }

                        this.appliedUsers[length] = this.logged_in_user.uid;
                    }

                    else {
                        this.appliedUsers = [];
                        this.appliedUsers[length] = this.logged_in_user.uid;
                    }
                    
                    firebase.database().ref('jobs/' + this.jobKey).update({Applied_users: this.appliedUsers});
                }

                this.$router.push(this.$route.path + "/applied");
            }

            
            

            
        }
    }
}
</script>


<style scoped>

    .card {
		margin-top:5px; 
		margin-bottom:20px; 
		padding-top:50px;
        padding-bottom:20px;
        padding-left:50px;
        padding-right:0px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
	}

    .content-start {
        margin-top:58px;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #job-content {
        margin-left:0%;
        margin-right:0%;
    }

    #job-content-text {
        padding-right:7%;
    }

</style>
